export default {
  mapping: state => {
    return state.mapping;
  },
  serialized: state => {
    return state.serialized;
  },
  valueForTopic: state => topic => {
    return state.mapping[topic];
  },
  topicFamilies: state => {
    return state.topicFamilies;
  },
  commandTopic: state => {
    return state.commandTopic;
  },
  mqttConnected: state => {
    return state.mqttConnected;
  },
  commandHistory: state => {
    return state.commandHistory;
  },
  localAccess: state => {
    return state.localAccess;
  },
  feedbackHistory: state => {
    return state.feedbackHistory;
  },
  tailFeedbackHistory: state => (opt) => {
    const lines = typeof opt !== "undefined" && typeof opt['lines'] !== "undefined" ? parseInt(opt['lines']) : 255;
    const topic = typeof opt !== "undefined" && typeof opt['topic'] !== "undefined" ? opt['topic'] : '';

    const filtered = state.feedbackHistory.filter(item => {
      return item.topic === topic;
    });

    const negative = 0 - lines;
    return filtered.slice(negative).reverse();
  }
};